import Vue from 'vue';
import Vuex from 'vuex';
Vue.use(Vuex);
export var store = new Vuex.Store({
  state: {
    serviceWorkerReady: false,
    clientMessageAllowed: false,
    greeting: ''
  },
  mutations: {
    SET_SERVICE_WORKER_READY(state) {
      var status = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : false;
      state.serviceWorkerReady = status;
    },

    SET_CLIENT_MESSAGE_ALLOWED(state) {
      var allow = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : false;
      state.clientMessageAllowed = allow;
    },

    SET_GREETING(state) {
      var greeting = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : '';
      state.greeting = greeting;
    }

  },
  actions: {
    set_service_worker_ready(_ref, status) {
      var {
        commit
      } = _ref;
      commit('SET_SERVICE_WORKER_READY', status);
    },

    set_client_message_allowed(_ref2, allow) {
      var {
        commit
      } = _ref2;
      commit('SET_CLIENT_MESSAGE_ALLOWED', allow);
    },

    set_greeting(_ref3, greeting) {
      var {
        commit
      } = _ref3;
      commit('SET_GREETING', greeting);
    }

  },
  modules: {}
});